// Component
import PageCard from "./PageCard";
import styles from "./PageCardGrid.module.css"

export default function PageCardGrid({content}) {
    const contentArray = Array.isArray(content) ? content : Object.values(content);

    return(
        <div className={styles.wrapper}>
            <div className={styles.grid}>
                {contentArray.map((pageInfo, index) => {
                    return <PageCard pageInfo={pageInfo} key={index}/>
                })}
            </div>
        </div>
    );
}